import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../compopnents/button";
import DatepickerDefault from "../../compopnents/datepicker";
import UploadFiled from "../../compopnents/fileduploader";
import Modal from "../../compopnents/modal";
import { skills } from "../../utils/Skill";
import { FormInput } from "../../wrappers/formInput";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { DropDownInput } from "../../wrappers/selectInput";
import * as Yup from "yup";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { getMilliSec, getMilliSecUTC } from "../../utils/ellowutils";
import AWS, { S3 } from 'aws-sdk';
import { Error } from "@progress/kendo-react-labels";
import {  postAPI } from '../../api/index'
import { REACT_APP_CANDIDATE_FREELANCER } from "../../utils/common";

const { v4: uuidv4 } = require("uuid");

export type ContractDetailsFormFields = {
  skills: any;
  duration: string;
  contractRate: any;
  startDate: any;
  endDate: any;
  timeBasis: any;
  currencyType: any;
  ellowRate: any;
  closedBy: any;
  supportingDocument: any;
  ellowBillingType: any;
  ellowCurrencyType: any;

};

interface props {
  onClose?: any;
  ClickHandler?: any;
  allocatedTo?: any;
  defaultvalues?:any;
  ellowRate?: any;
  currencyType?: any;
  billingType?: any;
}

const validationSchema = Yup.object({
  contractRate: Yup.string().required("Field is required"),
  ellowBillingType: Yup.string().required("Field is required").nullable(),
  ellowCurrencyType: Yup.string().required("Field is required").nullable(),
  ellowRate: Yup.string().required("Field is required").nullable(),
  closedBy: Yup.string().required("Field is required").nullable(),
  // startDate: Yup.string().required("Field is required").nullable(),
  // endDate: Yup.string().required("Field is required").nullable(),
});

const ContractDetails: React.FC<props> = ({
  onClose,
  ClickHandler,
  allocatedTo,
  defaultvalues,
  ellowRate,
  currencyType,
  billingType
}) => {

     useEffect(() => {  
      if (defaultvalues) {         
        if (defaultvalues.contractRate) {
          setRateValue(defaultvalues.contractRate)
        }
        if (defaultvalues.ellowRate) {
          setEllowRateValue(defaultvalues.ellowRate)
        }
        setValue('ellowRate',  defaultvalues.ellowRate)
        setValue('ellowBillingType', defaultvalues.timeBasis)
        setValue('ellowCurrencyType',defaultvalues.currencyType)
        if(defaultvalues.supportingDoc.length > 0){
          setDownloadResumeName(defaultvalues.supportingDoc)
          setResumeName((defaultvalues.supportingDoc.slice(36)))
        } 
      }
     
     }, [])
  
  
  const formOptions = { resolver: yupResolver(validationSchema), defaultValues: useMemo(() => {
    return defaultvalues;
  }, [defaultvalues])
  };
  
  const [resumeName, setResumeName] = useState<string | null>(null)
  const [DownloadresumeName, setDownloadResumeName] = useState<string | null>(null)
  const [ellowRateValue, setEllowRateValue] = useState<string>('');
  const [rateValue, setRateValue] = useState<string>('')
  const [error, setError] = useState<{ startDate?: string; endDate?: string }>({
    startDate: "",
    endDate: "",
  });


  const { register, handleSubmit, control, reset, setValue, formState } =
    useForm<ContractDetailsFormFields>(formOptions);

  
  const onSubmit = (data: any) => { 
    if (!data.startDate || !data.endDate) {
      if (!data.startDate && !data.endDate) {
        setError({startDate:'Field is required', endDate:'Field is required'})
      }
      else if (!data.startDate && data.endDate) {
        setError({startDate:'Field is required'})
      }
      else if (data.startDate && !data.endDate) {
        setError({endDate:'Field is required'})
      }
    }
    else {
      data.history = false
      ClickHandler(data);
    }
  
  };

  const handleChange = (event: any, value: string) => {
    if (value === "startDate" || value === "endDate") {
      if (value === 'startDate') {
        setValue(value, getMilliSecUTC(event.target.value));
        setError({startDate:'', endDate:error.endDate})
      }
      if (value === 'endDate') {
        setError({ endDate: '', startDate: error.startDate })
        setValue(value, getMilliSecUTC(event.target.value));
      }
    }
    if (value === "ellowRate") {
      setEllowRateValue(event.target.value ? Math.abs(event.target.value).toString() : "");
    }
    if (value === "rate") {
      setRateValue(event.target.value ? Math.abs(event.target.value).toString() : "")
    }
  };

const downloadHandle=(name:any)=>{
     
  const fileName=DownloadresumeName;
  let value = {
    "action":"getObject",
    "filename":fileName,
    "bucketName":"ellow-prod-doc-upload",
  };
  postAPI(REACT_APP_CANDIDATE_FREELANCER +'/api/v1/tg/resume-signed-url',value) .then((data) => {
  let signedUrl = data.url;
  const fileName=decodeURIComponent((name.slice(36, name.length)))  
  
  fetch(signedUrl).then(response => {
    
    response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download =fileName;
        alink.click();
    })
})
});
}


  return (
    <Modal title={"Contract Details "} size="medium" onClose={onClose}>
      <form>
        <div className="form-group">
          <MultiDropDownInput<ContractDetailsFormFields>
            name="skills"
            placeholder="Skills"
            register={register}
            data={skills}
            label="Skills"
            errors={formState.errors}
            control={control}
            dataItemKey="id"
            textField="name"
            disabled={true}
            defaultValue={defaultvalues && defaultvalues.skills}
          />
        </div>

        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Start Date*</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e, "startDate")}
              defaultValue={defaultvalues && defaultvalues.contractStartDate && new Date(defaultvalues.contractStartDate)}
              disabled={true}
            />
            <Error>{error?.startDate}</Error>
          </div>
          <div className="form-group">
            <label className="lablel">End Date*</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e, "endDate")}
              defaultValue={defaultvalues && defaultvalues.contractStartDate && new Date(defaultvalues.contractEndDate)}
              disabled={true}
            />
            <Error>{error?.endDate}</Error>
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="duration"
              data={CONSTANTS.contractDuration}
              register={register}
              errors={formState.errors}
              control={control}
              label="Duration"
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Sign In Date</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e, "signInDate")}
              defaultValue={defaultvalues && defaultvalues.signInDate && new Date(defaultvalues.signInDate)}
              disabled={true}
            />
            {/* <Error>{errors?.signInDate}</Error> */}
          </div>
          {/* <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="contractRate"
              type="number"
              register={register}
              errors={formState.errors}
              label="Rate*"
              value={rateValue}
              placeholder="Rate"
              onchange={(e: any) => handleChange(e, "rate")}

            />
          </div> */}
        </div>
        {/* <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="timeBasis"
              data={["Monthly", "Weekly", "Hourly"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Time Basis*"
            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="currencyType"
              data={["INR", "USD"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Currency Type*"
              defaultValue={defaultvalues && defaultvalues.currencyType}
            />
          </div>
        </div> */}
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="closedBy"
              data={allocatedTo}
              label="Position Closed By*"
              register={register}
              errors={formState.errors}
              control={control}
              defaultValue={defaultvalues && defaultvalues.closedBy}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <FormInput<ContractDetailsFormFields>
              name="ellowRate"
              label="ellow rate*"
              type="number"
              register={register}
              // value={ellowRate}
              errors={formState.errors}
              placeholder="Ellow Rate"
              onchange={(e: any) => handleChange(e, "ellowRate")}
              defaultValue={defaultvalues && defaultvalues.ellowRate}
              disabled={true}
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="ellowBillingType"
              data={["Monthly", "Weekly", "Hourly"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Time Basis*"
              disabled={true}
              defaultValue={defaultvalues && defaultvalues.timeBasis}
            />
          </div>
          <div className="form-group">
            <DropDownInput<ContractDetailsFormFields>
              name="ellowCurrencyType"
              data={["INR", "USD"]}
              register={register}
              errors={formState.errors}
              control={control}
              label="Currency Type*"
              defaultValue={defaultvalues && defaultvalues.currencyType}
              disabled={true}
            />
          </div>
        </div>
        <div className="form-wrap">
          <div className="form-group">
            <label className="lablel">
              Any additional supporting document?(optional)
            </label>
            <div className="uploadWrap">
               <label className="lablel">{defaultvalues && defaultvalues.supportingDoc !== "" ? <div onClick={()=>downloadHandle(DownloadresumeName)}>{resumeName}</div>  : 'Not Uploaded'}</label>
            </div>
          </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {/* <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Save
          </Button> */}
        </div>
      </form>
    </Modal>
  );
};

export default ContractDetails;
